/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDevSettingRequest
 */
export interface UpdateDevSettingRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDevSettingRequest
     */
    value: string;
}

/**
 * Check if a given object implements the UpdateDevSettingRequest interface.
 */
export function instanceOfUpdateDevSettingRequest(value: object): value is UpdateDevSettingRequest {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UpdateDevSettingRequestFromJSON(json: any): UpdateDevSettingRequest {
    return UpdateDevSettingRequestFromJSONTyped(json, false);
}

export function UpdateDevSettingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDevSettingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function UpdateDevSettingRequestToJSON(json: any): UpdateDevSettingRequest {
    return UpdateDevSettingRequestToJSONTyped(json, false);
}

export function UpdateDevSettingRequestToJSONTyped(value?: UpdateDevSettingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

